import React from 'react';
import './Input.scss';

import { Input } from '../../atoms/Forms/input'

interface InputFormProps {
  title?: string
  /**
   * Is this the principal call to action on the page?
   */
  placeholder?: string
  /**
   * Optional click handler
   */
  name?: string

  value?: string

  detail?: string

  description?: string

  unit?: string

  disabled?: boolean

  type?: 'text' | 'password' | 'number'

  onChange: ((event: React.ChangeEvent<HTMLInputElement>) => void | undefined)
}

/**
 * Primary UI component for user interaction
 */
export const InputForm = ({
  title,
  placeholder,
  type = 'text',
  name,
  value,
  detail,
  description,
  unit,
  disabled = false,
  onChange,
  ...props
}: InputFormProps) => {

  return (
    <>
        <div className="option-item">
            <h2 className="itemName">{ title }</h2>
            <div className="input-wapper">
                <div className="input-form">
                <Input
                    placeholder={placeholder}
                    name={name}
                    value={value}
                    disabled={disabled}
                    onChange={onChange}
                />
                </div>
                <div><p className="inputUnit">{ unit }</p></div>
            </div>
      </div>
    </>
  )
}